<template>
    <li v-if="notification && notification.item" :class="{'read': notification.item.read_at}">
        <div class="shift_notification__content">
            <small>{{ notification.item.created_at | moment }}</small>
            <a href="#" @click="handleNotification" v-if="notification.item">
                {{notification.message}}    
            </a>
            <div v-else>
                {{notification.message}}  
            </div>
            
        </div>
        
        <div class="shift_notification__actions">
            
            <span><i class="material-icons markasread" :class="{'read': notification.item.read_at}" @click="markAsRead">check</i></span>
            <span><i class="material-icons remove" @click="remove">clear</i></span>
        </div>
    </li>
</template>

<script>
    import moment from "moment";
    export default {
        props: ['item', 'idx'],
        filters: {
            moment: function (date) {
                return moment(date).format('DD-MM-YYYY HH:MM');
            }
        },
        computed: {
            notification(){
                switch (this.item.type) {
                    
                    case "Zorgbord\\Notifications\\AdminShiftCancelledNotification":
                        return {
                                type: 'shift_cancelled',
                                message: `De dienst ${this.item.data.company}\\${this.item.data.department} op ${moment(this.item.data.start_datetime).format('DD-MM-YYYY HH:mm')} is geannuleerd door ${this.item.data.cancelled_by.email}`,
                                item:  this.item
                            };
                            break;  
                    case "Zorgbord\\Notifications\\ShiftInterestedNotification":
                        return {
                            type: 'shift_interest',
                            message: `${this.item.notifiable.first_name} ${this.item.notifiable.last_name} heeft interesse in  ${this.item.data.company}\\${this.item.data.department} op ${moment(this.item.data.start_datetime).format('DD-MM-YYYY HH:mm')}`,
                            item: this.item
                        };
                        break;
                        
                    case "Zorgbord\\Notifications\\ShiftAcceptedNotification":
                        return {    
                            type: 'shift_accepted',
                            message: `${this.item.notifiable.first_name} ${this.item.notifiable.last_name} heeft ${this.item.data.company}\\${this.item.data.department} op ${moment(this.item.data.start_datetime).format('DD-MM-YYYY HH:mm')} geaccepteerd.`,
                            item: this.item
                        };
                        break;    
                    //  case "Zorgbord\\Notifications\\ShiftDeniedNotification":
                    //     return {    
                    //         type: 'shift_denied',
                    //         message: `${this.item.notifiable.first_name} ${this.item.notifiable.last_name} heeft ${this.item.data.company}\\${this.item.data.department} op ${moment(this.item.data.start_datetime).format('DD-MM-YYYY HH:mm')} afgewezen.`,
                    //         item: this.item
                    //     };
                    //     break;     
                    // default:
                    //     return {
                    //         type: 'default_message',
                    //         message: 'Standaard bericht',
                    //         item: this.item
                    //     };
                    //     break;
                }
            }
        },
        methods: {
            handleNotification(){
                if(this.notification.type === 'shift_interest' || this.notification.type === 'shift_accepted' || this.notification.type === 'shift_denied'  ){
                    let date = moment(this.notification.item.data.start_datetime).format('YYYY-MM-DD');
                    this.$router.push({ name: 'dashboard', query: { 'start_datetime': date, 'shift_id': this.notification.item.data.shift_id }});
                }
               

                // MARK AS READ IF IS NOT ALREADY
                if(this.notification.item.read_at === null){
                    this.markAsRead()
                }
            },
            async markAsRead(bool){
                try {
                    let read = await this.$axios.patch(`/users/shift_notifications/${this.item.id}/read`);
                    this.$emit('update', {
                        item: read.data,
                        idx: this.idx
                    });
                } catch (e) {
                    this.displayErrors(e.response.data.errors);
                }
            },
            async remove(){
                try {
                    let remove = await this.$axios.delete(`/users/shift_notifications/${this.item.id}`);
                    this.$emit('remove', this.idx);
                } catch (e) {

                    this.displayErrors(e.response.data.errors);
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/notification-shift-item.vue